import { useAccount } from 'apps/aquifer-frontend/src/auth';
import { useEntities } from 'apps/aquifer-frontend/src/data/flowEntities';
import React from 'react';
import ConnectorCard from '../ConnectorCard';
import { TextField } from '@mui/material';

const NameCard = ({
  entityType,
  entity,
  stepNumber,
  activeStep,
  catalogType,
  dispatch,
  onNextClick,
  onBackClick,
}) => {
  const { currentAccount } = useAccount();
  const [name, setName] = React.useState(entity.name || '');
  const [error, setError] = React.useState(null);
  const existingEntitiesQuery = useEntities(currentAccount.id, entityType, {
    filter: {
      name,
    },
  });

  React.useEffect(() => {
    if (entity.id) {
      dispatch({ type: 'change_validation_status', valid: true });
    } else if (
      name.length > 0 &&
      existingEntitiesQuery.data &&
      existingEntitiesQuery.data.length > 0
    ) {
      setError('Name already taken');
      dispatch({ type: 'change_validation_status', valid: false });
    }
  }, [name]);

  const handleNameChange = (newName) => {
    setName(newName);

    if (!/^[a-z][a-z0-9_]*$/.test(newName)) {
      setError(
        'Only lowercase letters (a-z), numbers (0-9), and underscores (_) are allowed, and it must begin with a letter.',
      );
      dispatch({ type: 'change_validation_status', valid: false });
    } else {
      setError(null);
      dispatch({ type: 'change_validation_status', valid: true });
      dispatch({ type: 'change_entity_name', name: newName });
    }
  };
  const completed = Boolean(name) && activeStep !== stepNumber - 1;
  const active = activeStep === stepNumber - 1;

  const helperText = `Please pick a unique name for your ${entityType}. Only lowercase letters (a-z), numbers (0-9), and underscores (_) are allowed, and it must begin with a letter.`;
  return (
    <ConnectorCard
      stepNumber={stepNumber}
      active={active}
      completed={completed}
      title="Connector Details"
      sx={{ marginBottom: '1em', tabIndex: active ? 0 : -1 }}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      renderChildren={(buttonsDisabled) => (
        <TextField
          fullWidth
          label="Connector Name"
          placeholder={catalogType.title}
          variant="outlined"
          disabled={Boolean(entity.id) || buttonsDisabled}
          value={name}
          onChange={(e) => handleNameChange(e.target.value)}
          error={error != null}
          helperText={error || helperText}
        />
      )}
    />
  );
};

export default NameCard;
